import { FCC, Row, Text } from '../view.box';

export const GridNoRows: FCC = ({ children }) => {
	return (
		<Row height="100%">
			<Text color="text.secondary">{children}</Text>
		</Row>
	);
};
